<template>
  <v-chip outlined :color="color" label>{{ etat | etatrequete }}</v-chip>
</template>

<script>
export default {
  props: {
    etat: {
      type: String,
      required: false,
    },
  },
  computed: {
    color() {
      if ("EN_COURS" === this.etat) {
        return "darkgrey";
      } else if ("REJETEE" === this.etat) {
        return "error";
      }
      return "primary";
    },
  },
};
</script>
